module.exports = __webpack_public_path__ + "img/loginbgr.eb913f95.jpg";